<fieldset class="border rounded-3 p-1" *ngIf="checkDataExists">
  <legend class="float-none w-auto px-1 font-size-13">{{'REVIEW_SOL_OT_PWR_TAB.TITLE' | translate}}</legend>
  <div class="row" *ngFor="let dataSource of groupedReviewList; let i = index">
    <div class="col-md-8">
      <div class="table-container mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" class="mat-table custom-table table-bordered" multiTemplateDataRows>
          <ng-container *ngFor="let column of columns" [matColumnDef]="column.field">
            <th mat-header-cell *matHeaderCellDef [style.width]="column.colWidth || 'auto'"
              class="custom-header">
              {{ column.field === 'description' ? (descriptionColumnList[i] || '') : (column.header | translate) }}
            </th>
            <td mat-cell *matCellDef="let element" class="custom-cell" (click)="setSelectedRow(element, element.levelID)"
              [ngClass]="{'selected-row': selectedRow[element.levelID] === element}" [class.right-align]="column.isRightAlign">
              {{ element[column.field] }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsOvertimeWise"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsOvertimeWise;"></tr>
        </table>
      </div>
    </div>
  </div>
</fieldset>

<div class="container-fluid customizeText" *ngIf="!checkDataExists">
  {{'REVIEW_SOL_OT_PWR_TAB.OT_PWR_DATA_NOT_FOUND' | translate}}
</div>